import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { projectServiceEndpoint } from "api/project";

import {
  SHAPEFILE_SOURCE,
  ShapefileSourceType
} from "components/project/layers/hooks/project-layer-tree/useProjectLayerTree.types";
import { useProjectContext } from "components/project/projects/context";
import {
  PROJECT_SHAPEFILES_QUERY_KEYS,
  SHAPEFILE_LIST_QUERY_KEYS
} from "components/project/shapefiles/queries";

import { useShapefileDispatch } from "../../context";

export interface IUseUpdateProjectLinkedShapefileFolderColourMutationParams {
  onError?: (error) => void;
  onMutate?: () => void;
  onSettled?: () => void;
  onSuccess?: (data) => void;
}

export type UpdateProjectLinkedShapefileFolderColourParamsT = {
  body: {
    key: string;
    value: string;
  };
  shapefileNodeId: string;
  projectId: string;
  type: ShapefileSourceType;
};

export function UpdateProjectLinkedShapefileColors(
  params: UpdateProjectLinkedShapefileFolderColourParamsT
) {
  const shapefileType =
    params.type === SHAPEFILE_SOURCE.ORG ? "Organization" : "McDaniel";
  const url = `${projectServiceEndpoint}/project-shapefile/colors/${params.projectId}/${params.shapefileNodeId}?type=${shapefileType}`;
  return axios.put(url, params.body);
}

export function useUpdateProjectLinkedShapefileFolderColourMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess
}: IUseUpdateProjectLinkedShapefileFolderColourMutationParams) {
  const queryClient = useQueryClient();
  const { selectedProjectId } = useProjectContext();
  const shapefileDispatch = useShapefileDispatch();
  return useMutation(
    (params: UpdateProjectLinkedShapefileFolderColourParamsT) =>
      UpdateProjectLinkedShapefileColors({ ...params }),
    {
      onMutate: onMutate && onMutate,
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [
            PROJECT_SHAPEFILES_QUERY_KEYS.currentProjectShapefiles,
            selectedProjectId
          ]
        });
        queryClient.invalidateQueries({
          queryKey: [
            SHAPEFILE_LIST_QUERY_KEYS.currentProjectShapefileList,
            selectedProjectId
          ]
        });
        shapefileDispatch({ payload: { isLoadingColors: false } });
        onSuccess && onSuccess(data);
      },
      onError: (error) => {
        shapefileDispatch({ payload: { isLoadingColors: false } });
        onError && onError(error);
      },
      onSettled: onSettled && onSettled
    }
  );
}
